<header id="page-topbar" [ngClass]="locale==Locales.BN_BN? 'font-bn-nav':'font-en'">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a [routerLink]="['/blog/', blogSlug, 'posts']" class="logo logo-dark">
          <span class="logo-sm">
              <img *ngIf="blogDetail?.logo" src="{{blogDetail?.logo}}" alt="" height="36">
              <img *ngIf="!blogDetail?.logo" src="assets/apanel/images/logos/logo.svg" alt="" height="36">
          </span>
          <span class="logo-lg">
              <img *ngIf="blogDetail?.logo" src="{{blogDetail?.logo}}" alt="" height="72">
              <img *ngIf="!blogDetail?.logo" src="assets/apanel/images/logos/logo-wide.svg" alt=""
                   height="72">
          </span>
        </a>

        <a [routerLink]="['/blog/', blogSlug, 'posts']" class="logo logo-light">
          <span class="logo-sm">
              <img src="assets/apanel/images/logos/logo.svg" alt="" height="36">
          </span>
          <span class="logo-lg">
              <img src="assets/apanel/images/logos/logo-wide.svg" alt="" height="72">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn"
              (click)="initLeftMenuCollapse()">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <form class="app-search d-none d-lg-block" (submit)="onSearch()">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{translations['Search..']}}" [formControl]="search">
          <span class="bx bx-search-alt" *ngIf="!search.value"></span>
          <a *ngIf="search.value" href="javascript: void(0);" (click)="clearSearch()">
            <span class="bx bx-x-circle text-danger"></span>
          </a>
        </div>
      </form>

      <!--      <div class="dropdown dropdown-mega d-none d-lg-block ms-2">-->
      <!--        <button type="button" class="btn header-item waves-effect" data-bs-toggle="dropdown" aria-haspopup="false"-->
      <!--                aria-expanded="false">-->
      <!--          <span key="t-megamenu">Apps</span>-->
      <!--          <i class="mdi mdi-chevron-down"></i>-->
      <!--        </button>-->
      <!--        <div class="dropdown-menu dropdown-megamenu">-->
      <!--          <div class="row">-->
      <!--            <div class="col-sm-8">-->

      <!--              <div class="row">-->
      <!--                <div class="col-md-4">-->
      <!--                  <h5 class="font-size-14" key="t-ui-components" *ngIf="hasPrivilege('CAN_TAKE_EXAM')">PollBox</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-lightbox"-->
      <!--                         routerLink="/dash/questionnaires">Questionnaires</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-range-slider" routerLink="/dash/polls">Polls</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-sweet-alert" routerLink="/dash/poll-options"-->
      <!--                         *ngIf="isAdmin">Poll Options</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-rating" *ngIf="isAdmin" routerLink="/dash/votes">Votes</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->

      <!--                <div class="col-md-4" *ngIf="isAdmin">-->
      <!--                  <h5 class="font-size-14" key="t-applications">Inventory</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/categories">Categories</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/brands">Brands</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/filterable-attributes">Filterable Attributes</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->

      <!--                <div class="col-md-4">-->
      <!--                  <h5 class="font-size-14" key="t-extra-pages">CMS</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-light-sidebar" routerLink="/cms/files">File Manager</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->

      <!--          </div>-->

      <!--        </div>-->
      <!--      </div>-->
    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item waves-effect"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img *ngIf="currentLocale===Locals.EN" id="header-lang-img" src="assets/apanel/images/flags/us.jpg"
               alt="Header Language" height="16">
          <img *ngIf="currentLocale===Locals.BN_BN" src="assets/apanel/images/flags/bn.png" alt="user-image"
               class="me-1" height="12">
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="en"
             (click)="setLocale(Locals.EN)">
            <img src="assets/apanel/images/flags/us.jpg" alt="user-image" class="me-1" height="12">
            <span class="align-middle">English</span>
          </a>
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="sp"
             (click)="setLocale(Locals.BN_BN)">
            <img src="assets/apanel/images/flags/bn.png" alt="user-image" class="me-1" height="12">
            <span class="align-middle">বাংলা</span>
          </a>
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen"
                (click)="toggleFullScreen($event)">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

<!--      <div class="dropdown d-inline-block">-->
<!--        <button type="button" class="btn header-item waves-effect"-->
<!--                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          <i class="mdi mdi-grid font-size-18"></i>-->
<!--        </button>-->
<!--        <div class="dropdown-menu dropdown-menu-end">-->
<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);"-->
<!--             class="dropdown-item notify-item language" data-lang="en"-->
<!--             (click)="onMenuTypeSelected(MenuTypes.VERTICAL)">-->
<!--            <i class="bx bx-dots-vertical"></i> &nbsp;-->
<!--            <span class="align-middle">Left Sidebar</span>-->
<!--          </a>-->
<!--          &lt;!&ndash; item&ndash;&gt;-->
<!--          <a href="javascript:void(0);"-->
<!--             class="dropdown-item notify-item language" data-lang="sp"-->
<!--             (click)="onMenuTypeSelected(MenuTypes.HORIZONTAL)">-->
<!--            <i class="bx bx-dots-horizontal"></i> &nbsp;-->
<!--            <span class="align-middle">Top Menu</span>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</header>
